import { useEffect } from 'react';

type Props = {
  apiKey: string;
};

export const TypeformSurveyInjector = ({ apiKey }: Props) => {
  useEffect(() => {
    const existingScript = document.querySelector('script[data-typeform-injected]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://embed.typeform.com/next/embed.js';
      script.async = true;
      script.setAttribute('data-typeform-injected', 'true');
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  if (!apiKey) {
    return null;
  }

  return (
    <div className='mini:!text-1420 mini:!py-1 pt-2 pb-2 flex justify-center'>
      <div data-tf-live={apiKey}></div>
    </div>
  );
};
